import { ScrollArea } from '#GameFrontend/components/ui/scroll-area';
import React from 'react';
import { useTranslation } from 'react-i18next';
const Terms: React.FC = () => {
	const { t } = useTranslation();
	return (
		<div className="flex-1 container mx-auto px-0 lg:px-4 lg:py-12 flex">
			<ScrollArea className="h-96 rounded-md p-4 bg-amber-100 bg-opacity-30">
				<h1 className="text-3xl">{t('terms.header')}</h1>
				<p>{t('terms.content')}</p>
			</ScrollArea>
		</div>
	);
};

export default Terms;
